var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Resource from './Resource';
import { api } from '../../helpers/Api';
import { action, observable } from 'mobx';
var ResourceStore = /** @class */ (function () {
    function ResourceStore() {
        var _this = this;
        this.data = [];
        this.loaded = false;
        this.set = function (values) {
            _this.data = values.map(function (item) { return new Resource(item); });
            _this.loaded = true;
            return _this.data;
        };
        this.push = function (value) {
            _this.data.push(new Resource(value));
        };
    }
    ResourceStore.prototype.read = function (id) {
        var _this = this;
        if (id) {
            return api.get("resources/".concat(id));
        }
        console.log('pidiendo resources');
        return api.get('resources')
            .then(function (data) {
            return _this.set(data);
        });
    };
    ResourceStore.prototype.create = function (data) {
        return api.post('resources', data);
    };
    ResourceStore.prototype.update = function (id, data) {
        return api.put("resources/".concat(id), data);
    };
    ResourceStore.prototype.delete = function (id) {
    };
    ResourceStore.prototype.disable = function (id) {
    };
    __decorate([
        observable
    ], ResourceStore.prototype, "data", void 0);
    __decorate([
        observable
    ], ResourceStore.prototype, "loaded", void 0);
    __decorate([
        action
    ], ResourceStore.prototype, "set", void 0);
    __decorate([
        action
    ], ResourceStore.prototype, "push", void 0);
    return ResourceStore;
}());
export default ResourceStore;



//////////////////
// WEBPACK FOOTER
// ./src/modules/Resources/Store.ts
// module id = 761
// module chunks = 0